import React, { useContext } from "react";
import { FilterContext } from "../filters-context";
const ResetFilters = () => {
  const { resetFilters } = useContext(FilterContext);
  return (
    <button
      className="filter-reset"
      onClick={() => {
        resetFilters();
      }}
    >
      Tous les épisodes
    </button>
  );
};

export default ResetFilters;
